import { getProductTypes } from 'app/functions/product';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ProductsId } from '@webc/meeseeks-ui-sdk';
import { ProductDataType, StoreProductField } from 'app/models/types/store/product';

const defaultState: StoreProductField = {
  types: getProductTypes(),
  relationProducts: getProductTypes(),
};

export const productSlice = createSlice({
  name: 'product',
  initialState: defaultState,
  reducers: {
    setProductQuantity(
      state,
      action: PayloadAction<{ productType: ProductsId; quantity: number }>,
    ) {
      const value = Number.isNaN(action.payload.quantity) ? 0 : action.payload.quantity;
      state.types[action.payload.productType].selectedAmount = value;
    },
    setRelationProducts(
      state,
      action: PayloadAction<{ relationProducts: { [key in ProductsId]?: ProductDataType } }>,
    ) {
      state.relationProducts = action.payload.relationProducts;
    },
    resetAllProducts(state) {
      state.types = getProductTypes(state.types);
    },
    removeBikesFromProducts(state) {
      state.types['bike_slot'].selectedAmount = 0;
      if (state.relationProducts['bike_slot']) {
        state.relationProducts['bike_slot'].selectedAmount = 0;
      }
    },
  },
});

export default productSlice.reducer;

export const {
  setProductQuantity,
  setRelationProducts,
  resetAllProducts,
  removeBikesFromProducts,
} = productSlice.actions;
